"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawLoops = void 0;
// TODO - finish
function drawLoops(g, loops) {
    return [];
}
exports.drawLoops = drawLoops;
//# sourceMappingURL=draw-loops.js.map